import React, { useState } from "react"
import { Button, Card, CardBody, Col, Form, Input, Label } from "reactstrap"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"
const EditBazaar = () => {
  const [addStall, setAddStall] = useState([])
  const [addItem, setAddItem] = useState([])
  const [inputValue, setInputValue] = useState("")

  // const [selectedStalls, setSelectedStalls] = useState([])
  /*   const [selectedStalls, setSelectedStalls] = useState([
    { label: "A1", value: "A1" },
    { label: "A2", value: "A2" },
  ]) */

  const [selectedStalls1, setSelectedStalls1] = useState([
    { label: "AL1", value: "AL1" },
    { label: "AL2", value: "AL2" },
    { label: "AL3", value: "AL3" },
  ])
  const [selectedStalls2, setSelectedStalls2] = useState([
    { label: "AF1", value: "AF1" },
    { label: "AF2", value: "AF2" },
    { label: "AF3", value: "AF3" },
  ])
  const createOption = value => ({
    label: value,
    value: value,
  })

  const handleInputChange = value => {
    setInputValue(value)
  }

  const handleKeyDown = event => {
    if (!inputValue) return

    // Trigger when user presses Enter or pastes with comma
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()

      const values = inputValue
        .split(/[, \n]+/) // split by comma, space, newline
        .map(v => v.trim())
        .filter(Boolean)

      const newOptions = values.map(createOption)

      setSelectedStalls1(prev => {
        const existing = prev.map(p => p.value)
        const filtered = newOptions.filter(opt => !existing.includes(opt.value))
        return [...prev, ...filtered]
      })

      setInputValue("")
    }
  }
  const handlePaste = event => {
    event.preventDefault()

    const pastedText = event.clipboardData.getData("text")

    const values = pastedText
      .split(/[, \n]+/)
      .map(v => v.trim())
      .filter(Boolean)

    const newOptions = values.map(createOption)

    setSelectedStalls1(prev => {
      const existing = prev.map(p => p.value)
      const filtered = newOptions.filter(opt => !existing.includes(opt.value))
      return [...prev, ...filtered]
    })
  }

  const handleAddStallOnClick = () => {
    const stall = { name2: "" }
    setAddStall([...addStall, stall])
  }

  const handleAddItemOnClick = () => {
    const item2 = { name1: "" }
    setAddItem([...addItem, item2])
  }

  const handleRemoveAddStallClick = index => {
    const updateStalls = [...addStall]
    updateStalls.splice(index, 1)
    setAddStall(updateStalls)
  }

  const handleRemoveRowClick = index => {
    const updateItems = [...addItem]
    updateItems.splice(index, 1)
    setAddItem(updateItems)
  }
  const handleRemoveStallRow = index => {
    const updateItems = [...addStall]
    updateItems.splice(index, 1)
    setAddStall(updateItems)
  }

  const keywordOptions = [
    {
      label: "Bags & Wallets",
      options: [
        {
          label: "L1",
          value: "L1",
        },
        {
          label: "L2",
          value: "L2",
        },
        {
          label: "L3",
          value: "L3",
        },
        {
          label: "L4",
          value: "L4",
        },
        {
          label: "L5",
          value: "L5",
        },
      ],
    },
  ]

  document.title = "Add Bazaar | PULA"
  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between mb-3"></div>

        <Form className="editbazaar-form">
          {/* Bazaar Details */}
          <Card>
            <CardBody>
              <div>
                <h4 className="nom-title">Bazaar Details</h4>
                <div className="border-top mt-3 pb-4 mb-1"></div>
                <Form>
                  <div className="row">
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="keywords">
                          Bazaar Name&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="bazaar_name"
                          className="form-control"
                          placeholder="Enter Bazaar Name"
                          value={"Christmas Special - Season 41	"}
                          type="text"
                          id="bazaar_name"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="location">
                          Location&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="location"
                          className="form-control"
                          placeholder="Select Location"
                          value={"Amanora Mall, Hadapsar, Pune"}
                          type="text"
                          id="location"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="start_date">
                          Start Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="MM DD, YYYY"
                          value={"December 12, 2025"}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="end_date">
                          End Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="MM DD, YYYY"
                          value={"December 28, 2025"}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group mb-3">
                        <Label htmlFor="time_input" className="form-label">
                          Time&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          className="form-control"
                          type="time"
                          defaultValue="13:45:00"
                          id="time_input"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="description">
                          Description&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <textarea
                          className="form-control"
                          id="description"
                          rows="5"
                          placeholder="Enter Description"
                          value={
                            "Booking on lst November, Saturday at 8am. Food Court of Amanora Mall, Hadapsar"
                          }
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </CardBody>
          </Card>

          {/* Stall Details */}
          <Card>
            <CardBody>
              <div className="row">
                <div className="col-12 col-sm-6">
                  <h4 className="nom-title">Stall Details</h4>
                </div>
                <div className="col-12 col-sm-6 d-flex justify-content-end align-items-center">
                  <Button
                    onClick={() => {
                      handleAddStallOnClick()
                    }}
                    color="primary"
                    size="md"
                    className="mt-3 mt-lg-0"
                  >
                    Add Stall +
                  </Button>
                </div>
              </div>
              <div className="border-top pb-4 mb-1"></div>

              <Form>
                <div className="first-stalldetails">
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_type">
                          Stall Type&nbsp;<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="stall_type"
                          className="form-control"
                          placeholder="Enter Stall Type"
                          value={"Red Two Side Open"}
                          type="text"
                          id="stall_type"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_size">
                          Stall Size&nbsp;<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="stall_size"
                          className="form-control"
                          placeholder="Pick the Stall Size"
                          type="text"
                          id="stall_size"
                          value={"10 * 10"}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-3">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_descr">
                          Stall Description
                        </Label>
                        <textarea
                          name="stall_descr"
                          className="form-control"
                          placeholder="Description"
                          type="text"
                          id="stall_descr"
                          rows="1"
                          value={"Two Side Open."}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-5 d-flex">
                      <div className="form-group mb-3 flex-grow-1">
                        <Label className="form-label" htmlFor="stall_no">
                          Stall Number&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <CreatableSelect
                          isMulti
                          placeholder="Add or select stalls"
                          options={[]} // no options in dropdown
                          value={selectedStalls1}
                          inputValue={inputValue}
                          onInputChange={handleInputChange}
                          onKeyDown={handleKeyDown}
                          onPaste={handlePaste}
                          onChange={setSelectedStalls1}
                          classNamePrefix="select"
                          formatCreateLabel={inputValue =>
                            `Add "${inputValue}"`
                          } // optional, custom create label
                        />

                        {/*    <Select
                        id="stall_no"
                        name="stall_no"
                        isMulti
                        options={keywordOptions}
                        classNamePrefix="select"
                      /> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_size">
                          Base Price&nbsp;<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="base_price"
                          className="form-control"
                          placeholder="Base Size"
                          type="text"
                          id="base_price"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3 plus-icon">
                        <Label className="form-label" htmlFor="stall_size">
                          2 Sided Price (optional)
                        </Label>
                        <Input
                          name="sided_price"
                          className="form-control"
                          placeholder="2 Sided Price"
                          type="text"
                          id="sided_price"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3 equal-icon">
                        <Label className="form-label" htmlFor="stall_cost">
                          Stall Cost<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="stall_cost"
                          className="form-control"
                          placeholder="Enter Stall Cost"
                          type="text"
                          id="stall_cost"
                          value={"28000"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="first-stalldetails">
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_type">
                          Stall Type&nbsp;<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="stall_type"
                          className="form-control"
                          placeholder="Enter Stall Type"
                          value={"Red Two Side Open"}
                          type="text"
                          id="stall_type"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_size">
                          Stall Size&nbsp;<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="stall_size"
                          className="form-control"
                          placeholder="Pick the Stall Size"
                          type="text"
                          id="stall_size"
                          value={"10 * 10"}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-3">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_descr">
                          Stall Description
                        </Label>
                        <textarea
                          name="stall_descr"
                          className="form-control"
                          placeholder="Enter Stall Number"
                          type="text"
                          id="stall_descr"
                          rows="1"
                          value={"Two Side Open."}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 col-xl-5 d-flex">
                      <div className="form-group mb-3 flex-grow-1">
                        <Label className="form-label" htmlFor="stall_no">
                          Stall Number&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <CreatableSelect
                          isMulti
                          placeholder="Add or select stalls"
                          options={[]} // no options in dropdown
                          value={selectedStalls1} // default selected
                          onChange={e => setSelectedStalls1(e)}
                          classNamePrefix="select"
                          formatCreateLabel={inputValue =>
                            `Add "${inputValue}"`
                          } // optional, custom create label
                        />

                        {/*    <Select
                        id="stall_no"
                        name="stall_no"
                        isMulti
                        options={keywordOptions}
                        classNamePrefix="select"
                      /> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3">
                        <Label className="form-label" htmlFor="stall_size">
                          Base Price&nbsp;<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="base_price"
                          className="form-control"
                          placeholder="Base Size"
                          type="text"
                          id="base_price"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3 plus-icon">
                        <Label className="form-label" htmlFor="stall_size">
                          2 Sided Price (optional)
                        </Label>
                        <Input
                          name="sided_price"
                          className="form-control"
                          placeholder="2 Sided Price"
                          type="text"
                          id="sided_price"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 position-relative">
                      <div className="form-group mb-3 equal-icon">
                        <Label className="form-label" htmlFor="stall_cost">
                          Stall Cost<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="stall_cost"
                          className="form-control"
                          placeholder="Enter Stall Cost"
                          type="text"
                          id="stall_cost"
                          value={"28000"}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-4">
                  {addStall.map((stall, index) => (
                    <React.Fragment key={index}>
                      <div className="border-top pb-3 mb-3"></div>

                      <div id={"addrNew" + index}>
                        <div data-repeater-item>
                          <div className="first-stalldetails">
                            <div className="row">
                              <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                                <div className="form-group mb-3">
                                  <Label
                                    className="form-label"
                                    htmlFor="stall_type"
                                  >
                                    Stall Type&nbsp;
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    name="stall_type"
                                    className="form-control"
                                    placeholder="Enter Stall Type"
                                    value={"Red Two Side Open"}
                                    type="text"
                                    id="stall_type"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                                <div className="form-group mb-3">
                                  <Label
                                    className="form-label"
                                    htmlFor="stall_size"
                                  >
                                    Stall Size&nbsp;
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    name="stall_size"
                                    className="form-control"
                                    placeholder="Pick the Stall Size"
                                    type="text"
                                    id="stall_size"
                                    value={"10 * 10"}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-6 col-lg-6 col-xl-3">
                                <div className="form-group mb-3">
                                  <Label
                                    className="form-label"
                                    htmlFor="stall_descr"
                                  >
                                    Stall Description
                                  </Label>
                                  <textarea
                                    name="stall_descr"
                                    className="form-control"
                                    placeholder="Enter Stall Number"
                                    type="text"
                                    id="stall_descr"
                                    rows="1"
                                    value={"Two Side Open."}
                                  ></textarea>
                                </div>
                              </div>
                              <div className="col-12 col-md-6 col-lg-6 col-xl-5 d-flex">
                                <div className="form-group mb-3 flex-grow-1">
                                  <Label
                                    className="form-label"
                                    htmlFor="stall_no"
                                  >
                                    Stall Number&nbsp;
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CreatableSelect
                                    isMulti
                                    placeholder="Add or select stalls"
                                    options={[]} // no options in dropdown
                                    value={selectedStalls1} // default selected
                                    onChange={e => setSelectedStalls1(e)}
                                    classNamePrefix="select"
                                    formatCreateLabel={inputValue =>
                                      `Add "${inputValue}"`
                                    } // optional, custom create label
                                  />

                                  {/*    <Select
                        id="stall_no"
                        name="stall_no"
                        isMulti
                        options={keywordOptions}
                        classNamePrefix="select"
                      /> */}
                                </div>
                              </div>
                            </div>
                            <div className="row align-items-end">
                              <div className="col-12 col-lg-3">
                                <div className="form-group mb-3">
                                  <Label
                                    className="form-label"
                                    htmlFor="stall_size"
                                  >
                                    Base Price&nbsp;
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    name="base_price"
                                    className="form-control"
                                    placeholder="Base Size"
                                    type="text"
                                    id="base_price"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-lg-3">
                                <div className="form-group mb-3 plus-icon">
                                  <Label
                                    className="form-label"
                                    htmlFor="stall_size"
                                  >
                                    2 Sided Price (optional)
                                  </Label>
                                  <Input
                                    name="sided_price"
                                    className="form-control"
                                    placeholder="2 Sided Price"
                                    type="text"
                                    id="sided_price"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-lg-3">
                                <div className="form-group mb-3 equal-icon">
                                  <Label
                                    className="form-label"
                                    htmlFor="stall_cost"
                                  >
                                    Stall Cost
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    name="stall_cost"
                                    className="form-control"
                                    placeholder="Enter Stall Cost"
                                    type="text"
                                    id="stall_cost"
                                    value={"28000"}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-lg-3 mb-3 pb-1">
                                <Button
                                  onClick={() => handleRemoveStallRow(index)}
                                  data-repeater-delete
                                  type="button"
                                  color="primary"
                                  className="btn-danger"
                                >
                                  <span>Delete</span>&nbsp;
                                  <i className="mdi mdi-delete"></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                </div>

                <div className="col-12 col-mt-5 d-flex justify-content-end align-items-center">
                  <Button
                    onClick={() => {
                      handleAddItemOnClick()
                    }}
                    color="primary"
                    size="md"
                    className="mt-3 mt-lg-0"
                  >
                    Add Items +
                  </Button>
                </div>
                <div className="row align-items-end">
                  <div className="mb-3 col-12 col-sm-6 col-lg-3">
                    <label className="form-label" htmlFor="name">
                      Item Name
                    </label>
                    <Input
                      type="text"
                      placeholder="Enter Item Name"
                      value={"Sharing"}
                      name="untyped-input"
                      className="form-control"
                    />
                  </div>

                  <div className="mb-3 col-12 col-sm-5 col-lg-3">
                    <label className="form-label" htmlFor="email">
                      Item Cost
                    </label>
                    <Input
                      type="item_cost"
                      placeholder="Enter Item Cost"
                      value={"4000"}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="row">
                  {addItem.map((item2, index) => (
                    <React.Fragment key={index}>
                      <div id={"addr" + index}>
                        <div data-repeater-item className="row align-items-end">
                          <div className="mb-3 col-12 col-sm-6 col-lg-3">
                            <label className="form-label" htmlFor="name">
                              Item Name
                            </label>
                            <Input
                              type="text"
                              name="untyped-input"
                              placeholder="Enter Item Name"
                              className="form-control"
                            />
                          </div>

                          <div className="mb-3 col-12 col-sm-5 col-lg-3">
                            <label className="form-label" htmlFor="email">
                              Item Cost
                            </label>
                            <Input
                              type="item_cost"
                              placeholder="Enter Item Cost"
                              className="form-control"
                            />
                          </div>

                          <div className="col-12 col-sm-1 mb-3 pb-1">
                            <Button
                              onClick={() => handleRemoveRowClick(index)}
                              data-repeater-delete
                              type="button"
                              size="sm"
                              color="primary"
                              className="btn-danger"
                            >
                              <i className="mdi mdi-delete"></i>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </Form>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-center mt-4">
            <Button
              type="submit"
              color="primary"
              className="w-20 btn btn-block font-size-16 mt-3"
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default EditBazaar
